var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.loader)?_c('div',{staticClass:"notification-loader"},[_c('span',[_vm._v("Carregando")]),_vm._v(" "),_c('v-loader')],1):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('footer',{staticClass:"page-footer"},[_vm._v("\n    Copyright © 2023. Vibbra\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd1490bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/components/page.vue
// module id = null
// module chunks = 